import { ajax } from 'discourse/lib/ajax';
import DiscourseRoute from 'discourse/routes/discourse';
import { logoFor } from './proxyviews-directory';

const TIER_LABEL = {
  basic: 'Verified',
  benchmark: 'Benchmark Verified',
  premium: 'Premium Verified',
};

export default class ProxyviewsProviderRoute extends DiscourseRoute {
  async model(params) {
    const data = await ajax(`/providers/${params.slug}.json`);
    const p = data.provider || {};
    const profile = data.profile || {};
    const tier = p.verification_tier;

    return {
      provider: {
        ...p,
        proxy_types: p.proxy_types || (p.proxy_type ? [p.proxy_type] : []),
        logo: logoFor(p),
        logoInitial: (p.name || '?').charAt(0).toUpperCase(),
        ratingDisplay: p.overall_rating ? Number(p.overall_rating).toFixed(1) : '—',
        costDisplay: (p.price_range_string || p.real_cost_per_gb) ? `$${p.price_range_string || p.real_cost_per_gb}` : '—',
        display_proxy_type: p.display_proxy_type ||
          (p.proxy_types && p.proxy_types.length
            ? p.proxy_types.map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(', ')
            : p.proxy_type
              ? p.proxy_type.charAt(0).toUpperCase() + p.proxy_type.slice(1)
              : 'Rotating'),
        tierLabel: tier && tier !== 'none' ? TIER_LABEL[tier] || 'Verified' : null,
        tierClass: tier && tier !== 'none' ? `pd-badge--verified-${tier}` : null,
        protocols: p.supported_protocols || [],
        countries: p.country_codes || [],
        // Affiliate CTA routes through the tracked /go/ redirect.
        goUrl: `/go/${p.slug}`,
        affiliateUrl: profile.affiliate_url,
        ctaText: profile.sidebar_cta_text || `Visit ${p.name}`,
      },
      profile: {
        ...profile,
        pros: profile.pros || [],
        cons: profile.cons || [],
        faq: profile.faq || [],
      },
      alternatives: (data.related_providers?.alternatives || []).map((alt) => {
        const altP = alt.provider || alt;
        return {
          ...altP,
          logo: logoFor(altP),
          logoInitial: (altP.name || '?').charAt(0).toUpperCase(),
          ratingDisplay: altP.overall_rating ? Number(altP.overall_rating).toFixed(1) : '—',
          display_proxy_type: altP.proxy_type
            ? altP.proxy_type.charAt(0).toUpperCase() + altP.proxy_type.slice(1)
            : 'Rotating',
          profileUrl: `/providers/${altP.slug}`,
        };
      }),
      recent_reviews: data.recent_reviews || [],
      review_summary: data.review_summary || {},
      changelog: data.changelog || [],
      latest_benchmark: data.latest_benchmark,
      related_guides: data.related_guides || [],
    };
  }

  titleToken() {
    return this.currentModel?.provider?.name || 'Provider';
  }
}
